import React from 'react';
import { motion } from 'framer-motion';
const rows = [{
  sin: 'Sin ejemplos argentinos',
  perdes: 'Alumnos desconectados que no entienden por qué la Criminalística argentina importa en el mundo'
}, {
  sin: 'Sin banco de casos',
  perdes: 'Horas semanales perdidas armando material desde cero'
}, {
  sin: 'Sin protocolo argentino actualizado',
  perdes: 'Clases con procedimientos desactualizados o de manuales extranjeros'
}, {
  sin: 'Sin banco de evaluaciones',
  perdes: 'Evaluaciones repetidas que no miden las competencias reales'
}, {
  sin: 'Sin recursos visuales',
  perdes: 'Sin infografías, diagramas ni fichas para el aula'
}, {
  sin: 'Sin conexión con la actualidad',
  perdes: 'Alumnos que no saben que Argentina tiene protocolos de IA forense y escaneo 3D desde 2026'
}, {
  sin: 'Sin planificaciones listas',
  perdes: 'Horas de diseño que podrían dedicarse a enseñar'
}];
export function CostComparison() {
  return <section className="py-20 bg-navy-900 text-white" data-id="element-18" data-mp="2lc3x78bpxcwq">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-19" data-mp="2pc4a2oj65g1o">
        <div className="text-center mb-12" data-id="element-20" data-mp="2pbul949v1exk">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-21" data-mp="2bcv4eisla4by">
            ⚖️ EL COSTO DE NO TENERLO
          </h2>
          <p className="text-xl text-silver" data-id="element-22" data-mp="2gawo95xua7oh">
            Lo que se paga con tiempo, cada semana, sin darte cuenta.
          </p>
        </div>

        <p className="text-center text-xs text-silver-dark mb-2 md:hidden" data-id="element-23" data-mp="21kp2ohcjc8jk">
          ← Deslizá para ver la tabla completa →
        </p>
        <div className="overflow-x-auto pb-4 mb-12" data-id="element-24" data-mp="1smn7wjjeac4q">
          <div className="min-w-[620px] max-w-3xl mx-auto" data-id="element-25" data-mp="1sny9ccpdb7so">
            <div className="grid grid-cols-2 gap-4 mb-4 px-4" data-id="element-26" data-mp="1xkf1dhzou6b1">
              <div className="font-bold text-silver-dark uppercase text-sm tracking-wider" data-id="element-27" data-mp="1inxnaj046dks">
                ❌ Sin el MEGAPACK
              </div>
              <div className="font-bold text-silver-light uppercase text-sm tracking-wider" data-id="element-28" data-mp="1nlz93boxcqzy">
                💸 Lo que realmente perdés
              </div>
            </div>

            <div className="space-y-2" data-id="element-29" data-mp="zr5ik8765h34">
              {rows.map(row => <div key={row.sin} className="grid grid-cols-2 gap-4 bg-navy-950/70 rounded-xl p-4 items-center border border-silver/15" data-id="element-30" data-mp="uslx08whm7ba">
                  <div className="text-silver font-medium text-sm" data-id="element-31" data-mp="progs1v1fncf">{row.sin}</div>
                  <div className="text-silver-light text-sm" data-id="element-32" data-mp="1ngi0bwgkaxh1">{row.perdes}</div>
                </div>)}
            </div>
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center bg-navy-800 rounded-2xl p-8 md:p-12 shadow-2xl border border-silver/30" data-id="element-33" data-mp="1di2bk050c0ap">
          <p className="md:text-3xl font-black text-white text-[20px] mb-6" data-id="element-34" data-mp="3tckonaw04rh4">
            🇦🇷🔍 "La próxima vez que un alumno pregunte para qué sirve estudiar
            Criminalística, podés mostrarle que Argentina fue el primer país del
            mundo en resolver un caso judicial con huellas dactilares, que tenemos
            el primer banco de datos genéticos de derechos humanos del planeta,
            que nuestros protocolos de evidencia digital están entre los más
            modernos de Latinoamérica, y que la ciencia forense argentina es
            referente internacional desde 1892. O podés seguir explicando sin ese
            contexto."
          </p>
          <p className="text-silver font-bold text-lg" data-id="element-35" data-mp="31hnw6ynm30r3">
            El mejor momento para tener este material era al inicio del ciclo
            lectivo. El segundo mejor momento es hoy.
          </p>
        </motion.div>
      </div>
    </section>;
}